module.exports = __webpack_public_path__ + "static/media/ceo_img.fac96dd0.jpg";